import React from "react";
import { useCurrentOrganization } from "web/hooks/useCurrentOrganization"
import { useCurrentUser } from "web/hooks/useCurrentUser";
import { subscribeBannerKind } from "./subscribeBannerLogic";

const CallToSubscribeBanner = () => {
    const {currentOrganization} = useCurrentOrganization();
    const user = useCurrentUser();

    // Decision logic lives in subscribeBannerLogic.ts (pure, unit-tested).
    const kind = subscribeBannerKind({
        isAdmin: !!user.isAdmin,
        isOwner: !!currentOrganization?.owners.find(o => o.id === user.id),
        orgHasHypercareEnabled: !!currentOrganization?.orgHasHypercareEnabled,
        nxVetSubscriptionStatus: currentOrganization?.nxVetSubscriptionStatus,
        nxHubSubscriptionStatus: currentOrganization?.nxHubSubscriptionStatus,
        nxClipSubscriptionStatus: currentOrganization?.nxClipSubscriptionStatus,
        isNxClipCustomer: !!currentOrganization?.isNxClipCustomer,
        hasNxVetForceSubscriptionEndDate: Boolean(currentOrganization?.nxVetForceSubscriptionEndDate),
    });

    switch (kind) {
        case 'none':
            return null;
        case 'expired-not-owner':
            return (
                <div className="w-full bg-gray-900 text-white p-2 text-center text-sm">
                    Your subscription has expired. Contact your organization owner to renew it.
                </div>
            );
        case 'expired-owner':
            return (
                <div className="w-full bg-gray-900 text-white p-2 text-center text-sm">
                    Your subscription has expired. See our current plans. <wbr /><a className="button primary !py-0 !px-2 mx-2" href="https://nx.vet/collections/frontpage" target="_blank" rel="noopener noreferrer">See plans &amp; pricing</a>
                </div>
            );
        case 'trial-not-owner':
            return (
                <div className="w-full bg-gray-900 text-white p-2 text-center text-sm">
                    Your free trial is expiring soon. Contact your organization owner to subscribe to a plan.
                </div>
            );
        case 'trial-owner':
            return (
                <div className="w-full bg-gray-900 text-white p-2 text-center text-sm">
                    Your free trial is expiring soon. <wbr />Upgrade to keep your features. <wbr /><a className="button primary !py-0 !px-2 mx-2" href="https://nx.vet/collections/frontpage" target="_blank" rel="noopener noreferrer">See plans &amp; pricing</a>
                </div>
            );
    }
};

export default CallToSubscribeBanner;
